import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'shards-react';

import VChart from './VChart';

const CHART_COLORS = [
  '#8445f7',
  '#007bff',
  '#17c671',
  '#fb7906',
  '#ff4169',
  '#00b8d8',
  '#818ea3',
  '#c4183c',
  '#ffd500',
  '#5a6169',
  '#9b59b6',
  '#3498db',
  '#2ecc71',
  '#e67e22',
  '#e74c3c',
];

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: 'right',
    labels: {
      padding: 7,
      boxWidth: 20,
    },
  },
};

const SubscriptionByPlan = ({ subscriptions, title }) => {
  const {
    datasets,
    labels,
    totals,
  } = useMemo(() => {
    const sortedSubscriptions = [...(Array.isArray(subscriptions)
      ? subscriptions
      : [])]
      .filter(item => item && Number(item.total || 0) > 0)
      .sort(
        (first, second) => Number(second.total || 0) - Number(first.total || 0),
      );
    const statusTotals = sortedSubscriptions.reduce((result, item) => ({
      current: result.current + Number(item.current || 0),
      expiredActive: result.expiredActive + Number(item.expiredActive || 0),
      total: result.total + Number(item.total || 0),
    }), {
      current: 0,
      expiredActive: 0,
      total: 0,
    });

    return {
      labels: sortedSubscriptions.map(item => item.label || 'Unknown plan'),
      datasets: sortedSubscriptions.length > 0
        ? [{
          data: sortedSubscriptions.map(item => Number(item.total || 0)),
          backgroundColor: sortedSubscriptions.map(
            (item, index) => CHART_COLORS[index % CHART_COLORS.length],
          ),
        }]
        : [],
      totals: statusTotals,
    };
  }, [subscriptions]);

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
        {labels.length > 0 && (
          <small className="text-muted">
            {`${totals.current.toLocaleString('en-US')} current`}
            {' \u2022 '}
            {`${totals.expiredActive.toLocaleString('en-US')} marked active but expired`}
          </small>
        )}
      </CardHeader>
      <CardBody className="py-3">
        {labels.length > 0 ? (
          <div
            className="w-100"
            style={{ height: '285px', position: 'relative' }}
          >
            <VChart
              labels={labels}
              datasets={datasets}
              type="pie"
              height="285"
              style={{ height: '100%', width: '100%' }}
              chartOptions={chartOptions}
            />
          </div>
        ) : (
          <div className="text-center text-muted w-100 p-4">
            No subscription records
          </div>
        )}
      </CardBody>
    </Card>
  );
};

SubscriptionByPlan.propTypes = {
  subscriptions: PropTypes.array,
  title: PropTypes.string,
};

SubscriptionByPlan.defaultProps = {
  subscriptions: [],
  title: 'Subscriptions by Plan',
};

export default SubscriptionByPlan;
